import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { MessageSquare, Phone, Activity } from 'lucide-react';
import { useWhatsAppAccounts, usePhoneNumbers, useHealthCheck } from '../hooks/useApi';

export default function Dashboard() {

    const { data: accounts, isLoading: accountsLoading } = useWhatsAppAccounts();
    const { data: phoneNumbers } = usePhoneNumbers();
    const { data: health } = useHealthCheck();

    const connectedAccounts = accounts?.filter(account => account.status === 'CONNECTED').length || 0;
    const totalAccounts = accounts?.length || 0;

    const totalPhoneNumbers = phoneNumbers?.length || 0;

    const stats = [
        {
            title: 'Contas Conectadas',
            value: `${connectedAccounts}/${totalAccounts}`,
            description: 'WhatsApp Business conectadas',
            icon: MessageSquare,
            color: 'text-green-600',
        },
        {
            title: 'Números de Telefone',
            value: totalPhoneNumbers.toString(),
            description: 'Números disponíveis',
            icon: Phone,
            color: 'text-blue-600',
        },
        {
            title: 'Status da API',
            value: health?.status === 'healthy' ? 'Online' : 'Offline',
            description: 'Conectividade com o servidor',
            icon: Activity,
            color: health?.status === 'healthy' ? 'text-green-600' : 'text-red-600',
        },
    ];

    return (
        <div className="space-y-6">
            <div>
                <h1 className="text-3xl font-bold text-blue-600">Dashboard</h1>
                <p className="text-gray-600">Visão geral do seu gerenciador WhatsApp</p>
            </div>

            {/* Stats Grid */}
            <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
                {stats.map((stat) => {
                    const Icon = stat.icon;
                    return (
                        <Card key={stat.title} className="border-blue-100 hover:border-blue-300 hover:shadow-lg transition-all bg-linear-to-br from-white to-blue-50/30">
                            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                                <CardTitle className="text-sm font-medium text-blue-700">
                                    {stat.title}
                                </CardTitle>
                                <Icon className={`h-4 w-4 ${stat.color}`} />
                            </CardHeader>
                            <CardContent>
                                <div className="text-2xl font-bold text-blue-600">{stat.value}</div>
                                <p className="text-xs text-gray-500">{stat.description}</p>
                            </CardContent>
                        </Card>
                    );
                })}
            </div>

            {/* Recent Accounts */}
            <Card className="border-blue-100">
                <CardHeader>
                    <CardTitle className="text-blue-600">Contas Recentes</CardTitle>
                    <CardDescription>
                        Últimas contas WhatsApp Business conectadas
                    </CardDescription>
                </CardHeader>
                <CardContent>
                    {accountsLoading ? (
                        <div className="text-center py-4">Carregando...</div>
                    ) : accounts && accounts.length > 0 ? (
                        <div className="space-y-4">
                            {accounts.slice(0, 5).map((account) => (
                                <div key={account.publicId} className="flex items-center justify-between p-4 border border-blue-200 rounded-lg hover:border-blue-400 hover:bg-blue-50/50 transition-all">
                                    <div className="flex items-center space-x-4">
                                        <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center ring-2 ring-blue-200">
                                            <MessageSquare className="w-5 h-5 text-blue-600" />
                                        </div>
                                        <div>
                                            <h3 className="font-medium">{account.name}</h3>
                                            <p className="text-sm text-gray-500">{account.channel}</p>
                                        </div>
                                    </div>
                                    <Badge variant={account.status === 'CONNECTED' ? 'success' : 'secondary'}>
                                        {account.status}
                                    </Badge>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="text-center py-8 text-gray-500">
                            Nenhuma conta conectada ainda
                        </div>
                    )}
                </CardContent>
            </Card>
        </div>
    );
}
